import { useState, useEffect, useRef } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';
import cn from 'classnames';

import LdsIcon from '../LdsIcon/index.jsx';

function LdsBackToTop({
  threshold = 100,
  backToTopText = 'Top',
  hideText = false,
  mobileOnly = false,
  scrollOffset = 0,
  scrollBehaviour = 'smooth',
  className = '',
  ...rest
}) {
  const [isShowing, setIsShowing] = useState(false);

  const buttonRef = useRef(null);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: scrollOffset,
      behavior: scrollBehaviour,
    });
  };

  useEffect(() => {
    const handleWindowScroll = () => {
      if (window.scrollY >= threshold) {
        setIsShowing(true);
      } else {
        setIsShowing(false);
      }
    };

    window.removeEventListener('scroll', handleWindowScroll);
    window.addEventListener('scroll', handleWindowScroll);
    return () => window.removeEventListener('scroll', handleWindowScroll);
  }, [threshold]);

  const transitionStyles = {
    entering: { opacity: 0, transform: 'translateX(1rem)' },
    entered: { opacity: 1, transform: 'translateX(0)' },
    exiting: { opacity: 0, transform: 'translateX(1rem)' },
    exited: { opacity: 0, transform: 'translateX(1rem)' },
  };

  return (
    <Transition
      nodeRef={buttonRef}
      in={isShowing}
      timeout={300}
    >
      { state => (
        <button
          ref={buttonRef}
          className={cn(
            'lds-button',
            'lds-back-to-top',
            {
              ['d-md-none']: mobileOnly,
            },
            className
          )}
          style={{ ...transitionStyles[state] }}
          onClick={handleScrollToTop}
          {...rest}
        >
          <LdsIcon className="back-to-top-icon" name="ArrowUp" decorative />
          <span className={`${hideText ? 'sr-only' : ''}`}>{backToTopText}</span>
        </button>
      )}
    </Transition>
  );
}

export default LdsBackToTop;

LdsBackToTop.propTypes = {
  backToTopText: PropTypes.string,
  hideText: PropTypes.bool,
  mobileOnly: PropTypes.bool,
  scrollOffset: PropTypes.number,
  scrollBehaviour: PropTypes.string,
  threshold: PropTypes.number,
};
